import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import { EAA_Add_Btn } from '~/components/EditAndAddItem';
import T_common from '~/components/TableItem/common';
import DefaultObject from './DefaultObject';
import Detail from './Detail';

class Actual extends Component {
  state={
    view_Detail: false,
    mode_Detail: '',
    data_num: undefined,
  }

  onAdd=(o = {}) => {
    const { data, onChange } = this.props;
    data.push(o);
    onChange(data);
  }

  onEdit=(o = {}) => {
    const { data, onChange } = this.props;
    const { data_num } = this.state;
    data[data_num] = o;
    onChange(data);
  }

  _add=() => this.setState({ view_Detail: true, mode_Detail: 'add' })
  _view=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'view' })
  _edit=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'edit' })
  _delete=i => {
    const { data, onChange } = this.props;
    data.splice(i, 1);
    onChange(data);
  }

  _close_Detail=() => this.setState({ data_num: undefined, view_Detail: false, mode_Detail: '' });

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '日期' },
      { name: '期間完成數量(非累計)' },
      { name: '備註' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { data, disabled } = this.props;
    const cellStyle = { fontSize: 14 };
    return (
      <TableBody>
        {data.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + 1}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actural_date}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actural_num}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.note}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(i)} />
                <T_Btn_Function disabled={disabled} text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(i)} style={{ marginLeft: 8, marginRight: 8 }} />
                <T_Btn_Function disabled={disabled} text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(i)} />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTable=() => (
    <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
      <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
        {this.renderTableTitle()}
        {this.renderTableBody()}
      </Table>
    </TableContainer>
  )

  render () {
    const { data, disabled, percentage } = this.props;
    const { view_Detail, mode_Detail, data_num } = this.state;
    const detail_data = !isNaN(data_num) ? data[data_num] : JSON.parse(JSON.stringify(DefaultObject));

    return (
      [
        <div key='Actual_Title' style={{ display: 'flex', marginTop: 24, alignItems: 'center' }}>
          <div style={{ fontWeight: 700, fontSize: 20, textAlign: 'start', marginRight: 8 }}>實際完成進度</div>
          <EAA_Add_Btn disabled={disabled} onClick={this._add} />
          <div style={{ flex: 1 }} />
          <div style={{ fontWeight: 500, fontSize: 16, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>
            {`完成數量百分比 ： ${percentage}%`}
          </div>
        </div>,
        <this.renderTable key='Actual_Table' />,
        <div key='Actual_Bar' style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }} />,
        view_Detail ? <Detail key='Actual_Detail' mode={mode_Detail} data={detail_data} onChange={o => !isNaN(data_num) ? this.onEdit(o) : this.onAdd(o)} _onClose={this._close_Detail} /> : null,
      ]
    );
  }
}

const mapStateToProps = state => ({

});
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Actual);
